import {Recipient} from "./types";

export function compareRecipients(recipients1: Recipient[], recipients2: Recipient[]) : boolean {
    return recipients1.length == recipients2.length
        && containsAll(recipients1, recipients2);
}

function containsAll(recipients1: Recipient[], recipients2: Recipient[]) {
    return recipients1.every(r1 => recipients2.find(r2 => compare(r1, r2)));
}

function compare(r1: Recipient, r2: Recipient) {
    return r1.recipientName == r2.recipientName && r1.email == r2.email;
}